<template>
       <vs-table :data="data" >
            <template slot="thead">
              <th>Standard Name</th>
              <th class="text-right">Client</th>
              <th class="text-right">Tacna Market</th>
              <th class="text-right">Ruiz Morales</th>
              <th class="text-right">AVG</th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(row, indextr) in data">                 
                <vs-td>{{row.name}}</vs-td>
                <vs-td class="text-right">$ {{formatNumber(row.client,2)}}</vs-td>
                <vs-td class="text-right">$ {{formatNumber(row.tacna_market,2)}}</vs-td>
                <vs-td class="text-right">$ {{formatNumber(row.ruiz_morales,2)}}</vs-td> 
                <vs-td 
                :class="(row.us_tacna.charAt(0) === '-') ? 'red-text' : 'green-text'" class="text-right">
                    <feather-icon :icon="(row.us_tacna.charAt(0) === '-') ? 'ChevronDownIcon': 'ChevronUpIcon'" style="width: rem; height: rem;" :class="(row.us_tacna.charAt(0) === '-') ? 'h-5 w-5 mr-4 red-text': 'h-5 w-5 mr-4 green-text'"></feather-icon>
                    $ {{ (row.us_tacna.charAt(0) === '-') ? formatNumber(parseFloat(row.us_tacna).toFixed(2).substr(1),2) : formatNumber(parseFloat(row.us_tacna),2)}}
                </vs-td>
                
                <template slot="expand">
                   <vs-table style="width:100%;" :data="row.childs">
                      <template slot="thead">
                        <vs-th>Standard Name</vs-th>
                        <vs-th>Base Weekly</vs-th>
                        <vs-th>Name</vs-th>
                        <vs-th>Hours</vs-th>
                        <vs-th>Current Payroll</vs-th>
                        <vs-th>Tacna Market</vs-th>
                        <vs-th>Ruiz Morales</vs-th>
                        <vs-th>MIN</vs-th>
                      </template>
                      <template slot-scope="{ data }">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">                 
                          <vs-td>{{tr.PRETTYNAME}}</vs-td>
                          <vs-td>{{tr.DAILY}}</vs-td>
                          <vs-td>{{tr.PU_DESCRIP}}</vs-td>
                          <vs-td>{{formatNumber(tr.NO_HORAS,2)}}</vs-td>
                          <vs-td>$ {{formatNumber(tr.SALARIO,2)}}</vs-td>
                          <vs-td>$ {{formatNumber(tr.REF_TACNA,2)}}</vs-td>
                          <vs-td>$ {{formatNumber(tr.REF_RUIZM,2)}}</vs-td>
                          <vs-td 
                          :class="(tr.REF_COMP.charAt(0) === '-') ? 'red-text' : 'green-text'">
                          <feather-icon :icon="(tr.REF_COMP.charAt(0) === '-') ? 'ChevronDownIcon': 'ChevronUpIcon'" style="width: rem; height: rem;" :class="(tr.REF_COMP.charAt(0) === '-') ? 'h-5 w-5 mr-4 red-text': 'h-5 w-5 mr-4 green-text'"></feather-icon>
                          $ {{ (tr.REF_COMP.charAt(0) === '-') ? formatNumber(parseFloat(tr.REF_COMP).toFixed(2).substr(1),2) : formatNumber(parseFloat(tr.REF_COMP),2)}}
                          </vs-td>                          
                        </vs-tr>
                      </template>
                    </vs-table>
                </template>
              </vs-tr>
            </template>
          </vs-table>
</template>


<script>
export default {
  components: {
  },
  computed: {
   
  },
  data: () => ({


  }),
  methods: {
    
  

  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {

  }
}
</script>

<style></style>
